import React from 'react';

const PaymentPrivacy = () => {
  return (
    <div className="py-12">
      <div className="max-w-3xl mx-auto px-4">
        <div className="bg-white rounded-xl p-8 border border-gray-200">
          <h1 className="text-2xl font-bold text-gray-900 mb-8">{"Politique de Confidentialité"}</h1>
          <p className="text-sm text-gray-400 mb-6">{"Dernière mise à jour : Décembre 2025"}</p>

          <div className="space-y-6 text-sm text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"1. Collecte des données"}</h2>
              <p>{"Nous collectons uniquement les données nécessaires au traitement de votre commande :"}</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>{"Adresse email (pour l\u2019accès à votre formation)"}</li>
                <li>{"Informations de paiement (traitées directement par Stripe, nous n\u2019y avons pas accès)"}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"2. Utilisation des données"}</h2>
              <p>{"Vos données sont utilisées exclusivement pour :"}</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>{"Le traitement et la confirmation de votre commande"}</li>
                <li>{"L\u2019attribution de votre accès à la formation"}</li>
                <li>{"La communication relative à votre achat (confirmation, support)"}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"3. Partage des données"}</h2>
              <p>{"Nous ne vendons, ne louons et ne partageons pas vos données personnelles avec des tiers, à l\u2019exception de :"}</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>{"Stripe : pour le traitement sécurisé du paiement"}</li>
                <li>{"Obligations légales : en cas de demande des autorités compétentes"}</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"4. Sécurité"}</h2>
              <p>{"Nous mettons en œuvre des mesures de sécurité techniques et organisationnelles appropriées pour protéger vos données contre tout accès non autorisé, modification, divulgation ou destruction."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"5. Vos droits (RGPD)"}</h2>
              <p>{"Vous disposez des droits suivants concernant vos données personnelles :"}</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>{"Droit d\u2019accès à vos données"}</li>
                <li>{"Droit de rectification"}</li>
                <li>{"Droit à l\u2019effacement"}</li>
                <li>{"Droit à la portabilité"}</li>
                <li>{"Droit d\u2019opposition au traitement"}</li>
              </ul>
              <p className="mt-2">{"Pour exercer ces droits, contactez-nous par email."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"6. Durée de conservation"}</h2>
              <p>{"Vos données sont conservées pendant la durée nécessaire aux finalités pour lesquelles elles ont été collectées, et conformément aux obligations légales en vigueur."}</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">{"7. Cookies"}</h2>
              <p>{"Notre site utilise uniquement des cookies essentiels au fonctionnement du service. Aucun cookie publicitaire ou de suivi n\u2019est installé."}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentPrivacy;
